export function addWhiteToIconUrl(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    if (parsed.pathname.endsWith('/')) return url;

    const match = parsed.pathname.match(/^(.*\/)?([^/]+)$/);
    if (!match) return url;

    const filename = match[2];
    const firstDotIndex = filename.indexOf('.');

    // if no extension -> return original
    if (firstDotIndex === -1) return url;

    const name = filename.substring(0, firstDotIndex);
    const rest = filename.substring(firstDotIndex);

    // Check if "-white" is already present in the filename
    if (name.endsWith('-white')) {
      return url; // Return original URL if "-white" already exists
    }

    const newFilename = `${name}-white${rest}`;
    parsed.pathname = (match[1] || '') + newFilename;

    return parsed.toString();
  } catch {
    return url;
  }
}

export function removeWhiteFromIconUrl(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    if (parsed.pathname.endsWith('/')) return url;

    const match = parsed.pathname.match(/^(.*\/)?([^/]+)$/);
    if (!match) return url;

    const filename = match[2];

    // remove -white only if it appears before the first extension or at the end
    const newFilename = filename.replace(/-white(?=\.|$)/, '');

    if (filename === newFilename) return url;

    parsed.pathname = (match[1] || '') + newFilename;
    return parsed.toString();
  } catch {
    return url;
  }
}
